import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTOGRAPHY_STATUSES } from 'domains/seller-inventory-batch/constants'

const propTypes = {
  photography_status: PropTypes.string
}

/**
 * To give nice look on Seller Inventory Batch `photography_status`.
 * It maps `photography_status` to certain style and pass to `StatusBadge`.
 * @param {string} photography_status Seller Inbound Inventory Batch Items. available values
 * - `pending`
 * - `complete`
 */
const PhotographyStatusBadge = ({ photography_status }) => {

  const colorMap = {
    [PHOTOGRAPHY_STATUSES.PENDING]  : 'warning',
    [PHOTOGRAPHY_STATUSES.COMPLETE] : 'success'
  }

  const color = colorMap[photography_status]

  return <StatusBadge color={ color } label={ photography_status } />
}

PhotographyStatusBadge.propTypes = propTypes

export default PhotographyStatusBadge